import { FormEvent } from 'react';

import { StyledInput, StyledLabel, StyledWrapper } from './InputField.styles';
import { IInputFieldProps } from './InputField.types';

const InputField = ({
  label,
  value,
  setValue,
  disabled,
  placeholder,
  type,
}: IInputFieldProps): JSX.Element => {
  const handleInputChange = (e: FormEvent<HTMLInputElement>) => {
    const newValue = (e.target as HTMLInputElement).value;
    if (setValue)
      setValue(prevValue => ({
        ...prevValue,
        value: newValue,
      }));
  };

  return (
    <StyledWrapper>
      <StyledLabel>{label}</StyledLabel>
      <StyledInput
        value={value}
        onChange={handleInputChange}
        disabled={disabled}
        placeholder={placeholder}
        type={type}
      />
    </StyledWrapper>
  );
};

export default InputField;
